import type { SVGProps } from 'react';
const SvgEnvelope = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M21 5H3c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h18c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm-9 7.016L5.084 7h13.834l-6.919 5.016zm-4.169-.553L3 16.294V7.96l4.831 3.503zm.819.593 2.175 1.578a2.004 2.004 0 0 0 2.35 0l2.175-1.578L20.294 17H3.707l4.944-4.944zm7.519-.593L21 7.96v8.334l-4.831-4.831z" />
  </svg>
);
export default SvgEnvelope;
